import { CustomBuilderComponents } from '@/helpers/enums';
import { DesignType } from './TextBox.types';

const designs = [...Object.values(DesignType)];

export const textBoxBuilderConfigs = {
  name: CustomBuilderComponents.TEXT_BOX,
  image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/format-text.svg',
  inputs: [
    {
      name: 'design',
      type: 'string',
      defaultValue: designs[0],
      enum: designs,
    },
    {
      name: 'body',
      friendlyName: 'Text body',
      type: 'customRichTextPistachios',
    },
  ],
};
